<template>
    <feed-url
        @change-step="handleProceed"
    >
        <h2>Let's connect to your existing podcast host</h2>
        <p class="small">
            To begin using our Fusebox podcast players, we need to find your existing show.
        </p>
    </feed-url>
</template>

<script>
import FeedUrl from '@/components/Shows/FeedUrl';

export default {
    components: {
        FeedUrl,
    },

    props: {
        data: {
            type: [Object],
            default: () => ({}),
        },
    },

    methods: {
        /**
         * Handle step change
         *
         * @param {object} show Show data.
         */
        handleProceed(show) {
            this.$emit('proceed', {
                ...this.data,
                show,
            });
        },
    },
};
</script>
